<template>
  <div class="home">
    <div v-if="isLoading">
      <spring-spinner
        class="spinner"
        slot="loading"
        :animation-duration="2500"
        :size="70"
        color="#4ae387"
      />
    </div>
    <vuestic-widget :header-text="$t('home.searchTitle')">
      <div class="va-row ">
        <div class="form-group with-icon-left flex full-width">
          <div class="row filters-page__filter-bar-container title-layout">
            <div class="form-group">
              <div class="input-group search">
                <input
                  id="search-input"
                  name="search-input"
                  required
                  autocomplete="off"
                  v-model="searchString"
                >
                <i class="fa fa-search icon-left input-icon" />
                <label
                  class="control-label"
                  for="search-input"
                >{{ $t('home.search') }}</label>
                <i class="bar" />
              </div>
            </div>
            <div class="form-group flex md2">
              <div class="input-group">
                <vuestic-date-picker
                  id="tripDurationFrom"
                  v-model="tripStartDate"
                  :config="dateConfig"
                />
                <label
                  class="control-label"
                  for="tripDurationFrom"
                >{{ $t('trip.create.durationFrom') }}</label>
                <i class="bar" />
              </div>
            </div>

            <div class="form-group flex md2">
              <div class="input-group">
                <vuestic-date-picker
                  id="tripDurationTo"
                  v-model="tripEndDate"
                  :config="dateConfig"
                />
                <label
                  class="control-label"
                  for="tripDurationTo"
                >{{ $t('trip.create.durationTo') }}</label>
                <i class="bar" />
              </div>
            </div>
            <vuestic-simple-select
              class="filters-page__filter-bar flex md2"
              :label="$t('home.searchStatus')"
              option-key="name"
              v-model="tripStatusTypeOption"
              :options="tripStatusTypes"
            />
          </div>
        </div>
      </div>
    </vuestic-widget>
    <div
      class="va-row"
      v-if="this.tripGrid.length==0 && this.trips.length > 0"
    >
      <div class="flex md4 offset--md4 no-results">
        <i class="fa fa-frown-o fa-5x pr-4" />
        <span>{{ $t('general.noSearchResults') }}</span>
      </div>
    </div>
    <div
      class="va-row"
      v-else-if="this.trips.length == 0 && isLoading==false"
    >
      <div class="flex md4 offset--md4 no-results">
        <i class="fa fa-frown-o fa-5x pr-4" />
        <span>{{ $t('general.noResults') }}</span>
      </div>
    </div>
    <div
      v-else
      v-for="row in this.tripGrid"
      class="trips-wrapper"
      :key="row"
    >
      <div class="va-row">
        <div class="flex md6 sm6">
          <trip-preview :trip="row[0]" />
        </div>
        <div
          class="flex md6 sm6"
          v-if="!!row[1]"
        >
          <trip-preview :trip="row[1]" />
        </div>
      </div>
    </div>
    <div
      class="va-row"
      v-if="this.showLoadMore"
    >
      <a
        @click="loadMore()"
        class="flex link md2 offset--md5"
      >{{ $t('general.loadMore') }}</a>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import { SpringSpinner } from 'epic-spinners';
import TripPreview from '../trip-preview/TripPreview.vue';
import { tripApi } from '../../services/api/tripApi';
import moment from 'moment';
import { dateLocaleBG, serverDateLocale } from '../../utils';

export default {
  name: 'HomeScreen',
  components: {
    SpringSpinner,
    TripPreview
  },
  created: function () {
    this.tripStatusTypeOption = { id: '1', name: this.$t('trip.status.active') };
  },
  data() {
    return {
      isLoading: false,
      trips: [],
      theSearchString: '',
      filterBy: 'title',
      pagination: {
        perPage: 50,
        currentPage: 1
      },
      dateConfig: {
        dateFormat: 'd.m.Y',
        locale: { firstDayOfWeek: 1 }
      },
      tripStartDate: new Date(),
      tripEndDate: '',
      tripStatusType: '',
      tripStatusTypeOption: null,
      tripStatusTypes: [
        { id: '', name: ' ' },
        { id: '1', name: this.$t('trip.status.active') },
        { id: '2', name: this.$t('trip.status.complete') },
        { id: '3', name: this.$t('trip.status.canceled') }
      ],
      showLoadMore: true,
    };
  },
  computed: {
    tripGrid() {
      return this.filteredResults.reduce(
        (rows, key, index) =>
          (index % 2 === 0
            ? rows.push([key])
            : rows[rows.length - 1].push(key)) && rows,
        []
      );
    },
    searchString: {
      get() {
        return this.theSearchString;
      },
      set: _.debounce(function (val) {
        this.theSearchString = val;
        this.triggerSearch();
      }, 500)
    },
    filteredResults() {
      return this.trips;
    }
  },
  watch: {
    tripStatusTypeOption: {
      handler() {
        this.tripStatusType = this.tripStatusTypeOption.id;
        this.pagination.currentPage = 1;
        this.triggerSearch();
      },
    },
    tripStartDate: {
      handler() {
        this.pagination.currentPage = 1;
        this.triggerSearch();
      },
    },
    tripEndDate: {
      handler() {
        this.pagination.currentPage = 1;
        this.triggerSearch();
      },
    },
  },
  methods: {
    loadMore() {
      this.pagination.currentPage += 1;
      this.getTripsPage().then(response => {
        let trips = response.trips;
        this.trips = this.trips.concat(trips);
        this.isLoading = false;
        this.showLoadMore = this.trips.length < response.count;
      });
    },
    getTripsPage() {
      let searchText = this.theSearchString;
      let startDate = this.tripStartDate;
      let endDate = this.tripEndDate;
      let from = '';
      let to = '';
      if (startDate !== '') {
        from = moment(startDate, dateLocaleBG).format(serverDateLocale);
      }
      if (endDate !== '') {
        to = moment(endDate, dateLocaleBG).format(serverDateLocale);
        to = parseInt(to);
      }
      let status = this.tripStatusType === undefined ? '' : this.tripStatusType;
      this.isLoading = true;
      return tripApi.search(searchText, from, to, status, this.pagination);
    },
    triggerSearch() {
      let searchText = this.theSearchString;
      let startDate = this.tripStartDate;
      let endDate = this.tripEndDate;
      let from = '';
      let to = '';
      if (startDate !== '') {
        from = moment(startDate, dateLocaleBG).format(serverDateLocale);
      }
      if (endDate !== '') {
        to = moment(endDate, dateLocaleBG).format(serverDateLocale);
        to = parseInt(to);
      }
      let status = this.tripStatusType === undefined ? '' : this.tripStatusType;
      this.isLoading = true;
      tripApi.search(searchText, from, to, status, this.pagination)
        .then(response => {
          this.trips = response.trips;
          this.showLoadMore = response.count > this.pagination.perPage;
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  }
};
</script>

<style lang="scss">
.home {
  .spinner {
    position: absolute;
    left: 50%;
    top: 50%;
  }
  .color-icon-label-table {
    td:first-child { width: 1rem; }
  }
  .link {
    color: #4ab2e3 !important;
  }
  .no-results {
    display: flex;
    align-items: center;

    & span::first-letter {
      text-transform: capitalize;
    }
  }
  .search {
    & #search-input:focus ~ label {
      font-size: 1.3rem !important;
      transform: translate(12px, -15px);
      text-transform: none;
    }

    & .control-label::first-letter {
      text-transform: capitalize;
    }
  }

  .title-layout {
    display: flex;
    justify-content: space-between;
  }

  .full-width {
    width: 100%;
  }

}
</style>
